import { ConfirmationModalContext, IDialogData } from 'contexts/ConfirmationModalProvider';
import { useContext } from 'react';

export type ModalContextType = {
    showConfirmation: (newData: IDialogData) => Promise<boolean>;
    hideConfirmation: () => void;
    isShown?: boolean;
    toggleLoading?: (loading: boolean) => void;
};

export const useConfirmationModalContext = (): ModalContextType => useContext(ConfirmationModalContext);
